import createModule from "../createModule"
import view from "./view"
import { Creators as PortfolioRootCreators } from "../portfolio-root/model"
import { Creators as ProfileCreators } from "model/profileModal"
import { getIsOpPro } from "modules/account-root/selectors"
import { getProfilePeriod } from "modules/portfolio-root/selectors/dates"
import { getFavoriteFactors } from "modules/portfolio-root/selectors/portfolios"
import { Creators as NotificationsCreators } from "modules/notifications/model"
import { getIsIntradayAnalyticsEnabled } from "selectors/features"
import { getFactorLabel, getFactorCategory, getPerformanceHistory, getNormalizedHistory, getCurrentNormalized, getPredictiveRiskHistory, getPredictiveRiskDriftValues } from "./selectors/data"
import { getSelectedDate, getEarliestDate, getLatestDate, getStartDate, getEndDate, getDatesAdjusted, getIsEndDateToday } from "./selectors/dates"

export default createModule({
  view,
  externalProps: state => ({
    account: state.global.selected.account,
    isOpPro: getIsOpPro(state),
    startDate: getStartDate(state),
    endDate: getEndDate(state),
  }),
  required: ["account", "modelId"],
  data: [{
    resource: "dates",
    as: null,
    url: ({ modelId }) => {
      if (!modelId) {
        return null
      }

      return {
        id: modelId,
        query: "query ($modelId: String!) { model (id: $modelId) { availability { currentDate, factorsStartDate, securitiesStartDate } } }",
        variables: { modelId },
      }
    },
  }, {
    resource: "factorProfilePerformance",
    url: ({ modelId, factorId, startDate, endDate }) => {
      if (!startDate || !endDate || !factorId) {
        return null
      }

      return {
        id: `factorProfilePerformance-${modelId}${factorId}${startDate}${endDate}`,
        query: `query ($modelId: String!, $factorId: [String], $from: Date!, $to: Date!) {
          model (id: $modelId) {
            factors (id: $factorId) {
              name,
              category,
              performance(from: $from, to: $to, interval: AUTO) {
                date, percentPriceChangeCumulative, normalizedReturn
             }
            }
          }
        }`,
        variables: {
          modelId,
          factorId,
          from: startDate,
          to: endDate,
        },
      }
    },
  }, {
    resource: "factorProfileRisk",
    url: ({ isOpPro, modelId, factorId, endDate, startDate }) => {
      if (isOpPro || !endDate || !startDate || !factorId) {
        return null
      }

      return {
        id: `factorProfileRisk-${modelId}${factorId}${startDate}${endDate}`,
        query: `query ($modelId: String!, $factorId: [String] $from: Date!, $to: Date!) {
          model (id: $modelId) {
            factors (id: $factorId) {
              id
              name
              category
              risk(from:$from, to:$to, type: PREDICTED) {
                date
                value
              }
            }
          }
        }`,
        variables: {
          modelId,
          factorId,
          from: startDate,
          to: endDate,
        },
      }
    },
  }],
  mapStateToProps: (state, props) => ({
    period: getProfilePeriod(state, props),
    date: getSelectedDate(state, props),
    performanceHistory: getPerformanceHistory(state, props),
    normalizedHistory: getNormalizedHistory(state, props),
    predictiveRisk: getPredictiveRiskHistory(state, props),
    predictiveRiskDriftValues: getPredictiveRiskDriftValues(state, props),
    currentNormalized: getCurrentNormalized(state, props),
    factorLabel: getFactorLabel(state, props),
    factorCategory: getFactorCategory(state, props),
    earliestDate: getEarliestDate(state, props),
    latestDate: getLatestDate(state, props),
    favoriteFactors: getFavoriteFactors(state, props),
    datesAdjusted: getDatesAdjusted(state, props),
    isIntradayAnalyticsEnabled: getIsIntradayAnalyticsEnabled(state),
    isEndDateToday: getIsEndDateToday(state, props),
  }),
  actions: {
    setDate: PortfolioRootCreators.setProfileDate,
    resetDate: PortfolioRootCreators.resetProfileDate,
    setPeriod: PortfolioRootCreators.setProfilePeriod,
    toggleFavoriteFactor: PortfolioRootCreators.toggleFavoriteFactor,
    addNotification: NotificationsCreators.add,
    openSecurityProfile: ProfileCreators.openSecurityProfile2,
    openFactorProfile: ProfileCreators.openFactorProfile,
  },
})
